module.exports = __webpack_public_path__ + "static/media/marker-grey-icon.1e3e9e57.svg";